import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
import Services from "../components/Sections/Services";
// import Projects from "../components/Sections/Projects";
// import Blog from "../components/Sections/Blog";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer"
import OurPartners from "../components/Sections/Partners";
export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    const scrollToId = location.state?.scrollTo;
    if (scrollToId) {
      const section = document.getElementById(scrollToId);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
        }, 300); // wait for DOM to render
      }
    }
  }, [location]);

  return (
    <>=
      <TopNavbar />
      <section id="home"><Header /></section>
      <section id="about"><Services /></section>
      {/* <section id="projects"><Projects /></section>
      <section id="blog"><Blog /></section> */}
      <section id="partners"><OurPartners /></section>
      <section id="contact"><Contact /></section>
      <Footer />
    </>
  );
}
